import { __makeTemplateObject, __assign } from 'tslib';
import React__default, { useState, useMemo } from 'react';
import shortid from 'shortid';
import styled from 'styled-components';
import { createContainer } from 'unstated-next';
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999999;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999999;\n"])), function (props) {
  return props.active ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0)';
});

var ModalState = function ModalState() {
  var _a = useState({}),
      modals = _a[0],
      setModals = _a[1];

  var modalsStack = useMemo(function () {
    return Object.keys(modals).map(function (key) {
      return modals[key];
    });
  }, [modals]);
  var lastModalKey = useMemo(function () {
    return Object.keys(modals)[Object.keys(modals).length - 1];
  }, [modals]);

  var close = function close(key) {
    var keyToRemove = key || lastModalKey;
    setModals(function (modals) {
      var newModals = __assign({}, modals);

      delete newModals[keyToRemove];
      return newModals;
    });
  };

  var open = function open(modal, key) {
    var id = "" + (key || shortid.generate());
    setModals(function (modals) {
      var newModals = __assign({}, modals);

      newModals[id] = React__default.cloneElement(modal, {
        id: id,
        dismiss: function dismiss() {
          return close(id);
        }
      });
      return newModals;
    });
    return id;
  };

  return {
    open: open,
    close: close,
    modals: modalsStack
  };
};

var ModalContainer = createContainer(ModalState);
var useModalState = ModalContainer.useContainer;

var Modals = function Modals() {
  var _a = useModalState(),
      modals = _a.modals,
      close = _a.close;

  if (modals.length === 0) return null;
  return React__default.createElement(React__default.Fragment, null, modals.map(function (m, i) {
    return React__default.createElement(Overlay, {
      onClick: function onClick() {
        return close();
      },
      active: i === modals.length - 1
    }, React__default.createElement("div", {
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
      },
      role: "alert"
    }, m));
  }));
};

var ModalProvider = function ModalProvider(props) {
  return React__default.createElement(ModalContainer.Provider, null, React__default.createElement(Modals, null), React__default.cloneElement(props.children, props));
};

var templateObject_1;
export { ModalProvider, useModalState };